import * as routes from 'api/routes';
import { IModel } from 'models/user/interface';

export type Params = void;
export type Result = Omit<IModel, '_id' | 'password'> & { _id: string; intercomHash: string };

export const ROUTE = routes.AUTH_USER_ME;
